import { Table } from "antd";
import { get } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../../../utils/utilities";

const BillingPlan = (props) => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const columns = [
    {
      title: "",
      width: 200 + 48, // 48 is the width of the summary table cell with the plus icon
      fixed: "left",
      render: () => t("projectEstimate.detail.tabs.kickOff.billingPlan"),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: ["columnValueMap", "AP"],
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: ["columnValueMap", "JANUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: ["columnValueMap", "FEBRUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: ["columnValueMap", "MARCH"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: ["columnValueMap", "APRIL"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: ["columnValueMap", "MAY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: ["columnValueMap", "JUNE"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: ["columnValueMap", "JULY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: ["columnValueMap", "AUGUST"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: ["columnValueMap", "SEPTEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: ["columnValueMap", "OCTOBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: ["columnValueMap", "NOVEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: ["columnValueMap", "DECEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: ["columnValueMap", "AS"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: ["columnValueMap", "TOT"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  return (
    <Table
      bordered
      dataSource={props.dataContentBillingPlan}
      columns={columns}
      size="small"
      pagination={false}
      scroll={{ x: 1500 }}
      rowClassName="table-primary"
    />
  );
};

export default BillingPlan;
